export const BADDERSWEB_ARRIVAL_EVENT = 'baddersweb_2026_27_arrival';
export const BADDERSWEB_VERIFY_EVENT = 'baddersweb_2026_27_arrival_verification';

// One matching document load, not one person or session. Reloads count again.
// Run at startup only, before client-side navigation can change the URL.
export const createBadderswebArrivalCapture = (capture) => {
  let checked = false;
  return (location, verificationMarker) => {
    if (checked) return;
    checked = true;
    if (location.pathname !== '/') return;
    const params = new URLSearchParams(location.search);
    const campaign = {
      utm_source: 'baddersweb',
      utm_medium: 'classified',
      utm_campaign: '2026_27',
    };
    if (!Object.entries(campaign).every(([key, value]) => {
      const values = params.getAll(key);
      return values.length === 1 && values[0] === value;
    })) return;

    const verification = Boolean(verificationMarker)
      || !['www.shuttleops.com', 'shuttleops.com'].includes(location.hostname);
    capture(verification ? BADDERSWEB_VERIFY_EVENT : BADDERSWEB_ARRIVAL_EVENT, {
      source: 'public_site',
      pathname: '/',
      route_template: '/',
    });
  };
};
